export default __webpack_public_path__ + "static/media/appspp.ee74eb56.png";